import { useEffect } from "react";
import { useRouter } from "next/navigation";
import useUser from "@/hooks/use-user";
import { getUserOrgs } from "@/services/users";
import { createOrganization } from "@/services/organizations/index";

export function useCheckUserOrg() {
    const { user, loading: userLoading } = useUser();
    const router = useRouter();

    useEffect(() => {
        const checkUserOrganizations = async () => {
            if (!userLoading && user) {
                try {
                    const orgs = await getUserOrgs();
                    const hasCreatedOrg = orgs.some((org: { created_by: string }) => org.created_by === user.email);

                    // if (!hasCreatedOrg) {
                    //     await createOrganization();
                    // }
                } catch (error) {
                    console.error(error);
                }
            }
        };

        checkUserOrganizations();
    }, [userLoading, user, router]);

    return { userLoading };
}